module.exports = __webpack_public_path__ + "img/编组 2.ccd88c37.png";